import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import Hhero from "../Components/Hhero";
import { Button, Container, Grid, Group,Text, Title, ThemeIcon, SimpleGrid, Textarea, TextInput, Box, Transition, Affix, ActionIcon, LoadingOverlay, Badge } from "@mantine/core";
import {useWindowScroll } from "@mantine/hooks";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WorkIcon from '@mui/icons-material/Work';
import PersonIcon from '@mui/icons-material/Person';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import VerifiedIcon from '@mui/icons-material/Verified';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { Alert, Card, message } from "antd";
import Oursolution from "../Components/Oursolution";
import Industryexperties from "../Components/Industryexperties";
import OurImpact from "../Components/OurImpact";

export const MOCKDATATwo = [
  {
    icon: <WorkIcon />,
    title: 'Expert Developers ​ ',
    description:
      'Our team consists of highly skilled professionals with deep technical expertise across modern tech stacks — ready to tackle any complex project with precision.',
  },
  {
    icon: <PersonIcon />,
    title: 'Experienced Skills ​',
    description:
      'With 30+ successful projects delivered globally, we bring industry insight and proven strategies to build scalable, high-performance solutions.',
  },
  {
    icon: <Diversity1Icon />,
    title: 'Client Friendly ​',
    description:
      'We believe in collaboration and clarity — always keeping you in the loop and making the development process smooth, transparent, and stress-free.',
  },
  {
    icon: <VerifiedIcon />,
    title: 'Trusted Work​​',
    description:
      'Our reputation is built on quality and commitment. We deliver what we promise — on time, on budget, and to your complete satisfaction.',
  },
];

const Home = () => {
  // const issmallscreen = useMediaQuery('(max-width: 768px)');
  const [scroll, scrollTo] = useWindowScroll();
  const [Inputs, setinputs] = useState({
    Subject: 'This mail intended by GV InfoTech Contact us.',
    Name: '',
    Mobile_number: '',
    Email_ID: '',
    Message: ''
  });
  const [loading, setloading] = useState(false);
  const [showalert, setshowalert] = useState(false);
  const Handleinputchange = (e) => {
    const { name, value } = e.target;
    setinputs({ ...Inputs, [name]: value });
  }

  const navigate = useNavigate();

  const handleMoreDetailsClick = () => {
    navigate("/contactus");
  }

  const Submit_Contact_us = async () => {
    const { Subject, Name, Mobile_number, Email_ID, Message } = Inputs;
    if (!Name || !Mobile_number || !Email_ID) {
      message.error("Please fill all required inputs");
      return;
    } else {
      setloading(true);
      const res = await fetch('https://formspree.io/f/xyzwalqn', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ Subject, Name, Mobile_number, Email_ID, Message })
      });

      if (res.status === 'ok' || res.status === 200) {
        message.success('Thanks form submitting contact form. We will be right back shortly!', 4);
        setinputs({
          Subject: 'This mail intended by GV InfoTech Contact us.',
          Name: '',
          Mobile_number: '',
          Email_ID: '',
          Message: ''
        });
        setloading(false);
        setshowalert(true);
        setTimeout(() => {
          setshowalert(false);
        }, 4000);
        return
      } else {
        message.error('oops! something went wrong.');
        setloading(false);
        return
      }
    }
  }
  return (
    <>
      <Navbar />
      <Hhero />
      <Affix position={{ bottom: 20, right: 20 }}>
        <Transition transition="slide-up" mounted={scroll.y > 0}>
          {(transitionStyles) => (
            <ActionIcon variant="filled" color="indigo" size="xl" radius="xl" aria-label="Settings" onClick={() => scrollTo({ y: 0 })}>
              <KeyboardDoubleArrowUpIcon style={{ width: '70%', height: '70%', transitionStyles }} stroke={1.5} />
            </ActionIcon>
          )}
        </Transition>
      </Affix>
      <Container mt={"xl"} size={"lg"} data-aos="fade-right">
        {/* <Group justify="center" mt={'md'} mb={'md'}>
          <Title size={'40'} c={'lime'}>-- About us --</Title>
        </Group> */}
        {/* <Grid>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <Image src={Aboutimg} alt="About us" h={500} w={500} style={{ display: issmallscreen ? 'none' : 'flex' }} />
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
            <Title size={30} c={"dimmed"}>
              Welcome to GV InfoTech!
            </Title>
            <Text mt={"md"} size="md">
              At GV InfoTech, we are dedicated to transforming your
              ideas into innovative digital solutions. With a keen focus on
              software development, app development, and website development, we
              leverage our diverse expertise to deliver high-quality services
              tailored to your specific needs.
            </Text>
            <Text mt={"md"} size="md">
              Our team comprises skilled professionals proficient in the latest
              technologies and best practices. We believe in the power of
              collaboration and work closely with our clients to ensure their
              visions are realized with precision and creativity.
            </Text>
            <Button variant="outline" color="black" size="lg" radius={'sm'} onClick={handleReadMoreClick} mt={'md'}>Read More</Button>
          </Grid.Col>
        </Grid> */}
        <Oursolution />
      </Container>


      <Container mt={"xl"} size={"lg"} data-aos="fade-right">
        {/* <Group justify="center" mt={'md'}>
          <Title size={'40'} c={'lime'}>-- Our Services --</Title>
        </Group> */}
        {/* <Featurecard /> */}
        <Industryexperties />
      </Container>
      <Container mt={"xl"} size={"lg"} data-aos="fade-right">
        {/* <Group justify="center" mt={'md'}>
          <Title size={'40'} c={'lime'}>-- Our Services --</Title>
        </Group> */}
        {/* <Featurecard /> */}
        <OurImpact />
      </Container>

      <Container mt={"xl"} size={"lg"} data-aos="fade-right">
        {/* <Group justify="center" mt={'md'} mb={'md'}>
          <Title size={'40'} c={'lime'}>--Contact us --</Title>
        </Group> */}
        <Group justify='center' mt={'xl'}>
          <Badge variant="outline" size="lg" p={'lg'} mt={'xl'} className='heading-pills'>
            Get In Touch
          </Badge>
        </Group>
        <Container mt={"xs"} size={"lg"} data-aos="fade-right">
          <Title ta={'center'} className='heading-as-text' size={'60'}>
            Talk to Our Experts
          </Title>
          <Group justify='center'>
            <Text c={'white'} fw={'bold'} className='heading-description' mt={'md'}>
              Ready to accelerate your digital transformation? Let's discuss your project and explore how we can help.
            </Text>
          </Group>
        </Container>

        <Grid>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }} mt={'md'}>
            <Title c={'dimmed'} mt={'md'}>Why Choose GV InfoTech.org?</Title>
            <Text size="md" c={'dimmed'} mt={'sm'}>
              At GV InfoTech, we don’t just deliver services — we deliver confidence. With a strong foundation in cutting-edge technologies and a client-first approach, we’ve earned the trust of businesses both local and global. Here’s why clients choose us:
            </Text>
            <SimpleGrid
              mt={30}
              cols={{ base: 1, sm: 2, md: 2 }}
              spacing={{ base: 'xl', md: 50 }}
              verticalSpacing={{ base: 'xl', md: 50 }}
            >
              {
                MOCKDATATwo.map((ele, idx) => {
                  return (
                    <div key={idx}>
                      <ThemeIcon variant="light" size={40} radius={40}>
                        {ele.icon}
                      </ThemeIcon>
                      <Text mt="sm" mb={7} fw={500} c={'white'}>
                        {ele.title}
                      </Text>
                      <Text size="xs" lineHeight={1} c={'grey'}>
                        {ele.description}
                      </Text>
                    </div>
                  );
                })
              }
            </SimpleGrid>
          </Grid.Col>
          <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }} mt={'md'}>
            <Card title={<Group justify="space-between"><span style={{color: 'white'}}>Connect with us!</span> <Button size="xs" variant="light" onClick={handleMoreDetailsClick}>More Details</Button></Group>}
              style={{ height: '100%', marginTop: '10px' }} className="heading-card">
              <Box pos="relative">
                <Alert message="Your form successfully submitted!" type="success" showIcon style={{ display: showalert ? 'flex' : 'none' }} />
                <LoadingOverlay
                  visible={loading}
                  zIndex={1000}
                  overlayProps={{ radius: 'sm', blur: 2 }}
                  loaderProps={{ color: 'indigo', type: 'bars' }}
                />
                <Box>
                  <Alert message="Contact details" description="Call us: +91 977-387-0841, +91 770-183-6668"/>
                </Box>
                <TextInput placeholder="Name (Required)" radius={'md'} name="Name" value={Inputs.Name} onChange={Handleinputchange} withAsterisk required mt={'xs'}  size="md"></TextInput>
                <TextInput placeholder="Mobile number (Required)" radius={'md'} name="Mobile_number" value={Inputs.Mobile_number} onChange={Handleinputchange} withAsterisk required mt={'lg'} minLength={10} maxLength={10} size="md"></TextInput>
                <TextInput placeholder="Email id (Required)" radius={'md'} name="Email_ID" value={Inputs.Email_ID} onChange={Handleinputchange} withAsterisk required mt={'lg'} size="md"></TextInput>
                <Textarea placeholder="Any message (Optional)" radius={'md'} mt={'lg'} size="md" name="Message" value={Inputs.Message} onChange={Handleinputchange} rows={3}></Textarea>
                <Button mt={'md'} size="lg" color="indigo" onClick={Submit_Contact_us} loading={loading} disabled={loading} variant="outline" fullWidth>Submit Form</Button>
              </Box>
            </Card>
          </Grid.Col>
        </Grid>
      </Container >


      <Footer />
    </>
  );
};

export default Home;
